import { getFriendlyErrorMessage, NETWORK_ERROR_MESSAGE } from "../../utils/apiErrors";

const API_BASE_URL = process.env.REACT_APP_BE_API_URL;

/**
 * Envía un formulario de contacto
 * @param contactData - Datos del formulario (name, email, companyName, phone, message)
 * @param recaptchaToken - Token de reCAPTCHA
 * @returns Respuesta del servidor
 */
export const submitContactForm = async (contactData: any, recaptchaToken: string | null): Promise<any> => {
  try {
    const response = await fetch(`${API_BASE_URL}/contactFormMessages/submit`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...contactData,
        recaptchaToken,
      }),
    });

    if (!response.ok) {
      let friendlyMessage = "";
      
      try {
        const errorData = await response.json();
        friendlyMessage = errorData.message || errorData.error;
      } catch (e) {
        // No hay JSON o mensaje en la respuesta
      }

      if (!friendlyMessage) {
        friendlyMessage = getFriendlyErrorMessage(response.status, 'contact');
      }
      
      const error = new Error(friendlyMessage);
      (error as any).friendlyMessage = friendlyMessage;
      (error as any).status = response.status;
      throw error;
    }

    return await response.json();
  } catch (error: any) {
    if (error.friendlyMessage) throw error;
    
    const networkError = new Error("Error de conexión");
    (networkError as any).friendlyMessage = NETWORK_ERROR_MESSAGE;
    throw networkError;
  }
};
